export const defaultLatLng = { latitude: 25.5, longitude: 51.483334 };
